// extracted by mini-css-extract-plugin
export default {"container":"GR-z","modal":"HR-z","dimensions":"IR-z","brandName":"JR-z","productName":"KR-z","labelValue":"LR-z","recipientEmail":"MR-z","recommendedFit":"NR-z","hiddenField":"OR-z"};